import type { Theme } from '@mui/material/styles';
import type { TypographyStyle } from '@mui/material/styles';
import { pxToRem } from '@/@mui/utils/px-to-rem';

interface HeadingStyles {
  h1: TypographyStyle;
  h2: TypographyStyle;
  h3: TypographyStyle;
}

export const generateCustomHeadingStyles = (theme: Theme): HeadingStyles => {
  return {
    h1: {
      ...theme.typography.h1,
      fontSize: pxToRem(22),
      '&:not(:first-child)': {
        marginTop: theme.spacing(6),
      },
    },
    h2: {
      ...theme.typography.h2,
      '&:not(:first-child)': {
        marginTop: theme.spacing(6),
      },
    },
    h3: {
      ...theme.typography.h3,
      '&:not(:first-child)': {
        marginTop: theme.spacing(6),
      },
    },
  };
};
